import React from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "../IndustriesWeWorkWith/IndustiresWeWorkTogether.css";

// Import icons for each industry (you'll need to replace these with actual icon imports)
import PetroleumIcon from "../../../icons/TourismIcons/CHINA-ICON.png";
import RealEstateIcon from "../../../icons/TourismIcons/CHINA-ICON.png";
import AutomobilesIcon from "../../../icons/TourismIcons/CHINA-ICON.png";
import BankingIcon from "../../../icons/TourismIcons/CHINA-ICON.png";
import TextileIcon from "../../../icons/TourismIcons/CHINA-ICON.png";
import PaintIcon from "../../../icons/TourismIcons/CHINA-ICON.png";
import AgroSeedsIcon from "../../../icons/TourismIcons/CHINA-ICON.png";
import ConsumerDurablesIcon from "../../../icons/TourismIcons/CHINA-ICON.png";
import MediaIcon from "../../../icons/TourismIcons/CHINA-ICON.png";
import TelecomIcon from "../../../icons/TourismIcons/CHINA-ICON.png";
import FMCGIcon from "../../../icons/TourismIcons/CHINA-ICON.png";
import PharmaceuticalsIcon from "../../../icons/TourismIcons/CHINA-ICON.png";

const Industries = () => {
  // Array of industry objects with name and icon
  const industriesData = [
    { name: "Petroleum", icon: PetroleumIcon },
    { name: "Real Estate", icon: RealEstateIcon },
    { name: "Automobiles", icon: AutomobilesIcon },
    { name: "Banking & Finance", icon: BankingIcon },
    { name: "Textile", icon: TextileIcon },
    { name: "Paint", icon: PaintIcon },
    { name: "Agro Seeds", icon: AgroSeedsIcon },
    { name: "Consumer Durables", icon: ConsumerDurablesIcon },
    { name: "Media", icon: MediaIcon },
    { name: "Telecom", icon: TelecomIcon },
    { name: "FMCG", icon: FMCGIcon },
    { name: "Pharmaceuticals", icon: PharmaceuticalsIcon }
  ];

  return (
    <div className='Industries-Main-div'>
      <h1 className='headings text-center'>
        <span>Industries </span>We Work With
      </h1>
      <div className='container Industries-container'>
        <div className='row'>
          {industriesData.map((industry, index) => (
            <div key={index} className='col-md-4 mb-3 text-center d-flex align-items-center'>
              <LazyLoadImage
            effect="blur"
 
                src={industry.icon} 
                alt={industry.name} 
                className='img-fluid mb-2 me-3'
                style={{ maxWidth: '100px', height: 'auto' }}
              />
              <div className='industries-text'>{industry.name}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Industries;